const routeMain = () => "/about";

export default routeMain;
